exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap .cover[data-v-65970f5a] {\n  z-index: 100;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.wrap .cover.transition[data-v-65970f5a] {\n    transition: background-color 0.3s;\n}\n.wrap .container[data-v-65970f5a] {\n  width: 100%;\n  position: fixed;\n  z-index: 101;\n  top: 0;\n}\n", ""]);

// exports
